import { useEffect, type ReactNode } from "react";
import { setOnUnauthorized } from "@/api/axios";
import * as authApi from "@/api/auth.api";
import { useAppDispatch, useAppSelector } from "@/store";
import {
  fetchCurrentUser,
  logout as logoutThunk,
  deleteAccount as deleteThunk,
  clearAuth,
} from "@/store/authSlice";

export function AuthInit({ children }: { children: ReactNode }) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    setOnUnauthorized(() => dispatch(clearAuth()));
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchCurrentUser());
  }, [dispatch]);

  return <>{children}</>;
}

export function useAuth() {
  const dispatch = useAppDispatch();
  const { user, isAuthenticated, loading } = useAppSelector((s) => s.auth);

  return {
    user,
    isAuthenticated,
    loading,
    loginWithGoogle: () => {
      window.location.href = authApi.getGoogleAuthUrl();
    },
    logout: () => dispatch(logoutThunk()).unwrap(),
    deleteAccount: () => dispatch(deleteThunk()).unwrap(),
  };
}
